import { m as d, S as _, a as T, H as S, A as R, D as k } from "./globals-BnV4aVvu.js";
import { c as k1, B as V1, C as B1, I as z1, b as A1, d as _1, s as T1 } from "./globals-BnV4aVvu.js";
import * as a from "react";
import O, { forwardRef as P } from "react";
import { jsx as t, jsxs as l, Fragment as V } from "react/jsx-runtime";
import N from "classnames";
const j = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "var(--green-500)", "aria-hidden": "true", "data-icon": "check-circle", "data-prefix": "fas", viewBox: "0 0 512 512", ...e }, /* @__PURE__ */ a.createElement("path", { fill: "#fff", d: "M91.8 150.2h328.4v249H91.8z" }), /* @__PURE__ */ a.createElement("path", { d: "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248M227.3 387.3l184-184c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-6.2-6.2-16.4-6.2-22.6 0L216 308.1 145.9 238c-6.2-6.2-16.4-6.2-22.6 0l-22.6 22.6c-6.2 6.2-6.2 16.4 0 22.6l104 104c6.2 6.4 16.4 6.4 22.6.1" })), Ie = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 512 512", ...e }, /* @__PURE__ */ a.createElement("path", { d: "M476 3.2 12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2" })), He = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ a.createElement("path", { fill: "none", d: "M0 0h24v24H0z" }), /* @__PURE__ */ a.createElement("path", { d: "M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21z" })), Le = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, "aria-hidden": "true", "data-icon": "chevron-left", "data-prefix": "fas", viewBox: "0 0 320 512", ...e }, /* @__PURE__ */ a.createElement("path", { fill: "currentColor", d: "M34.52 239.03 228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94" })), G = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, "aria-hidden": "true", "data-icon": "chevron-right", "data-prefix": "fas", viewBox: "0 0 320 512", ...e }, /* @__PURE__ */ a.createElement("path", { fill: "currentColor", d: "M285.476 272.971 91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941" })), ke = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 97.385 97.385", ...e }, /* @__PURE__ */ a.createElement("path", { d: "M97.265 71.261a.5.5 0 0 0-.374-.172H.494a.494.494 0 0 0-.489.568c.014.09 1.468 9.016 12.753 9.016h71.869c11.284 0 12.738-8.926 12.753-9.016a.5.5 0 0 0-.115-.396m-41.323 6.286h-14.5v-3.334h14.5zm-45.435-9.928h76.37a2 2 0 0 0 2-2V18.713a2 2 0 0 0-2-2h-76.37a2 2 0 0 0-2 2v46.906a2 2 0 0 0 2 2m5-43.906h66.37v36.906h-66.37z" })), Ve = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 457.03 457.03", ...e }, /* @__PURE__ */ a.createElement("path", { d: "m421.512 207.074-85.795 85.767c-47.352 47.38-124.169 47.38-171.529 0-7.46-7.439-13.296-15.821-18.421-24.465l39.864-39.861c1.895-1.911 4.235-3.006 6.471-4.296 2.756 9.416 7.567 18.33 14.972 25.736 23.648 23.667 62.128 23.634 85.762 0l85.768-85.765c23.666-23.664 23.666-62.135 0-85.781-23.635-23.646-62.105-23.646-85.768 0l-30.499 30.532c-24.75-9.637-51.415-12.228-77.373-8.424l64.991-64.989c47.38-47.371 124.177-47.371 171.557 0 47.357 47.369 47.357 124.178 0 171.546m-226.804 141.03-30.521 30.532c-23.646 23.634-62.128 23.634-85.778 0-23.648-23.667-23.648-62.138 0-85.795l85.778-85.767c23.665-23.662 62.121-23.662 85.767 0 7.388 7.39 12.204 16.302 14.986 25.706 2.249-1.307 4.56-2.369 6.454-4.266l39.861-39.845c-5.092-8.678-10.958-17.03-18.421-24.477-47.348-47.371-124.172-47.371-171.543 0L35.526 249.96c-47.366 47.385-47.366 124.172 0 171.553 47.371 47.356 124.177 47.356 171.547 0l65.008-65.003c-25.972 3.826-52.644 1.213-77.373-8.406" })), Be = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 448 512", ...e }, /* @__PURE__ */ a.createElement("path", { d: "M433.9 65.9 382 14a48 48 0 0 0-33.9-14H176c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v320c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48v-48h80c26.5 0 48-21.5 48-48V99.9A48 48 0 0 0 433.9 66zM266 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h74v224c0 26.5 21.5 48 48 48h96v42a6 6 0 0 1-6 6m128-96H182a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h106v88c0 13.3 10.7 24 24 24h88v202a6 6 0 0 1-6 6m6-256h-64V48h9.6c1.6 0 3.1.6 4.2 1.8l48.4 48.4a6 6 0 0 1 1.8 4.2z" })), ze = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 320 512", ...e }, /* @__PURE__ */ a.createElement("path", { d: "M160 0c17.7 0 32 14.3 32 32v35.7c1.6.2 3.1.4 4.7.7.4.1.7.1 1.1.2l48 8.8c17.4 3.2 28.9 19.9 25.7 37.2s-19.9 28.9-37.2 25.7l-47.5-8.7c-31.3-4.6-58.9-1.5-78.3 6.2s-27.2 18.3-29 28.1c-2 10.7-.5 16.7 1.2 20.4 1.8 3.9 5.5 8.3 12.8 13.2 16.3 10.7 41.3 17.7 73.7 26.3l2.9.8c28.6 7.6 63.6 16.8 89.6 33.8 14.2 9.3 27.6 21.9 35.9 39.5 8.5 17.9 10.3 37.9 6.4 59.2-6.9 38-33.1 63.4-65.6 76.7-13.7 5.6-28.6 9.2-44.4 11V480c0 17.7-14.3 32-32 32s-32-14.3-32-32v-34.9c-.4-.1-.9-.1-1.3-.2h-.2c-24.4-3.8-64.5-14.3-91.5-26.3-16.1-7.2-23.4-26.1-16.2-42.2S44.9 353 61 360.2c20.9 9.3 55.3 18.5 75.2 21.6 31.9 4.7 58.2 2 76-5.3 16.9-6.9 24.6-16.9 26.8-28.9 1.9-10.6.4-16.7-1.3-20.4-1.9-4-5.6-8.4-13-13.3-16.4-10.7-41.5-17.7-74-26.3l-2.8-.7c-28.5-7.6-63.5-16.9-89.5-33.9-14.2-9.3-27.5-22-35.8-39.6-8.4-17.9-10.1-37.9-6.1-59.2 7.2-38.2 35.8-63 68.3-75.9 13.3-5.3 27.9-8.9 43.2-11V32c0-17.7 14.3-32 32-32" })), Ae = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", ...e }, /* @__PURE__ */ a.createElement("path", { fill: "currentColor", d: "M362.7 19.32c25-24.998 65.6-24.998 90.6 0l39.4 39.43c25 24.99 25 65.55 0 90.55l-48.4 48.4-130-129.98zm59 200.98L188.5 453.4c-10.4 10.4-23.3 18.1-37.4 22.2L30.77 511c-8.42 2.5-17.53.2-23.74-6.9-6.21-5.3-8.532-14.4-6.054-22.9L36.37 360.9c4.16-14.1 11.79-27 22.2-37.4L291.7 90.34z" })), _e = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 512 512", ...e }, /* @__PURE__ */ a.createElement("path", { fill: "currentColor", d: "M208 281.4c-12.5-12.5-32.76-12.5-45.26-.002l-78.06 78.07-30.06-30.06a31.98 31.98 0 0 0-22.63-9.367 31.974 31.974 0 0 0-32 31.99v135.1C.001 501.3 10.75 512 24 512h136c12.94 0 24.63-7.797 29.56-19.75a31.95 31.95 0 0 0-6.938-34.87l-30.06-30.06 78.06-78.07c12.5-12.49 12.5-32.75.002-45.25zM487.1 0h-136c-12.94 0-24.63 7.797-29.56 19.75a31.95 31.95 0 0 0 6.938 34.87l30.06 30.06-78.06 78.07c-12.5 12.5-12.5 32.76 0 45.26l22.62 22.62c12.5 12.5 32.76 12.5 45.26 0l78.06-78.07 30.06 30.06c9.156 9.141 22.87 11.84 34.87 6.937C504.2 184.6 512 172.9 512 159.1v-136C512 10.74 501.3 0 487.1 0" })), Te = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, "aria-hidden": "true", "data-icon": "file-download", "data-prefix": "fas", viewBox: "0 0 384 512", ...e }, /* @__PURE__ */ a.createElement("path", { fill: "currentColor", d: "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24m76.45 211.36-96.42 95.7c-6.65 6.61-17.39 6.61-24.04 0l-96.42-95.7C73.42 337.29 80.54 320 94.82 320H160v-80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v80h65.18c14.28 0 21.4 17.29 11.27 27.36M377 105 279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9" })), Re = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, "aria-hidden": "true", viewBox: "0 0 512 512", ...e }, /* @__PURE__ */ a.createElement("path", { fill: "currentColor", d: "M432 320h-32a16 16 0 0 0-16 16v112H64V128h144a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16H48a48 48 0 0 0-48 48v352a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V336a16 16 0 0 0-16-16M488 0H360c-21.37 0-32.05 25.91-17 41l35.73 35.73L135 320.37a24 24 0 0 0 0 34L157.67 377a24 24 0 0 0 34 0l243.61-243.68L471 169c15 15 41 4.5 41-17V24a24 24 0 0 0-24-24" })), Oe = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, "aria-hidden": "true", "data-icon": "facebook", "data-prefix": "fab", viewBox: "0 0 512 512", ...e }, /* @__PURE__ */ a.createElement("path", { fill: "currentColor", d: "M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256" })), Pe = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, "aria-hidden": "true", viewBox: "0 0 512 512", ...e }, /* @__PURE__ */ a.createElement("path", { fill: "currentColor", d: "M504 255.531c.253 136.64-111.18 248.372-247.82 248.468-59.015.042-113.223-20.53-155.822-54.911-11.077-8.94-11.905-25.541-1.839-35.607l11.267-11.267c8.609-8.609 22.353-9.551 31.891-1.984C173.062 425.135 212.781 440 256 440c101.705 0 184-82.311 184-184 0-101.705-82.311-184-184-184-48.814 0-93.149 18.969-126.068 49.932l50.754 50.754c10.08 10.08 2.941 27.314-11.313 27.314H24c-8.837 0-16-7.163-16-16V38.627c0-14.254 17.234-21.393 27.314-11.314l49.372 49.372C129.209 34.136 189.552 8 256 8c136.81 0 247.747 110.78 248 247.531m-180.912 78.784 9.823-12.63c8.138-10.463 6.253-25.542-4.21-33.679L288 256.349V152c0-13.255-10.745-24-24-24h-16c-13.255 0-24 10.745-24 24v135.651l65.409 50.874c10.463 8.137 25.541 6.253 33.679-4.21" })), je = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 169.063 169.063", ...e }, /* @__PURE__ */ a.createElement("path", { d: "M122.406 0H46.654C20.929 0 0 20.93 0 46.655v75.752c0 25.726 20.929 46.655 46.654 46.655h75.752c25.727 0 46.656-20.93 46.656-46.655V46.655C169.063 20.93 148.133 0 122.406 0m31.657 122.407c0 17.455-14.201 31.655-31.656 31.655H46.654C29.2 154.063 15 139.862 15 122.407V46.655C15 29.201 29.2 15 46.654 15h75.752c17.455 0 31.656 14.201 31.656 31.655z" }), /* @__PURE__ */ a.createElement("path", { d: "M84.531 40.97c-24.021 0-43.563 19.542-43.563 43.563 0 24.02 19.542 43.561 43.563 43.561s43.563-19.541 43.563-43.561c0-24.021-19.542-43.563-43.563-43.563m0 72.123c-15.749 0-28.563-12.812-28.563-28.561s12.813-28.563 28.563-28.563 28.563 12.813 28.563 28.563-12.814 28.561-28.563 28.561M129.921 28.251c-2.89 0-5.729 1.17-7.77 3.22a11.05 11.05 0 0 0-3.23 7.78c0 2.891 1.18 5.73 3.23 7.78 2.04 2.04 4.88 3.22 7.77 3.22 2.9 0 5.73-1.18 7.78-3.22 2.05-2.05 3.22-4.89 3.22-7.78 0-2.9-1.17-5.74-3.22-7.78-2.04-2.05-4.88-3.22-7.78-3.22" })), Ge = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, "aria-hidden": "true", "data-icon": "bars", "data-prefix": "fas", viewBox: "0 0 448 512", ...e }, /* @__PURE__ */ a.createElement("path", { fill: "currentColor", d: "M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16m0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16m0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16" })), Ue = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 448 512", ...e }, /* @__PURE__ */ a.createElement("path", { fill: "currentColor", d: "M432 256c0 17.7-14.3 32-32 32H48c-17.7 0-32-14.3-32-32s14.3-32 32-32h352c17.7 0 32 14.3 32 32" })), Fe = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", "aria-hidden": "true", "data-icon": "music", "data-prefix": "fas", viewBox: "0 0 512 512", ...e }, /* @__PURE__ */ a.createElement("path", { d: "M470.38 1.51 150.41 96A32 32 0 0 0 128 126.51v261.41A139 139 0 0 0 96 384c-53 0-96 28.66-96 64s43 64 96 64 96-28.66 96-64V214.32l256-75v184.61a138.4 138.4 0 0 0-32-3.93c-53 0-96 28.66-96 64s43 64 96 64 96-28.65 96-64V32a32 32 0 0 0-41.62-30.49" })), De = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, "aria-hidden": "true", "data-icon": "step-forward", "data-prefix": "fas", viewBox: "0 0 448 512", ...e }, /* @__PURE__ */ a.createElement("path", { fill: "currentColor", d: "M384 44v424c0 6.6-5.4 12-12 12h-48c-6.6 0-12-5.4-12-12V291.6l-195.5 181C95.9 489.7 64 475.4 64 448V64c0-27.4 31.9-41.7 52.5-24.6L312 219.3V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12" })), Xe = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 448 512", ...e }, /* @__PURE__ */ a.createElement("path", { fill: "currentColor", d: "M312 320h136V56c0-13.3-10.7-24-24-24H24C10.7 32 0 42.7 0 56v400c0 13.3 10.7 24 24 24h264V344c0-13.2 10.8-24 24-24m129 55-98 98c-4.5 4.5-10.6 7-17 7h-6V352h128v6.1c0 6.3-2.5 12.4-7 16.9" })), We = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, "aria-hidden": "true", "data-icon": "pause-circle", "data-prefix": "far", viewBox: "0 0 512 512", ...e }, /* @__PURE__ */ a.createElement("path", { fill: "currentColor", d: "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8m0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200m96-280v160c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16m-112 0v160c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16" })), $e = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, "aria-hidden": "true", "data-icon": "users", "data-prefix": "fas", viewBox: "0 0 640 512", ...e }, /* @__PURE__ */ a.createElement("path", { fill: "currentColor", d: "M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64m448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64m32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64m-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112m76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2m-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4" })), Ye = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 27.442 27.442", ...e }, /* @__PURE__ */ a.createElement("path", { d: "M19.494 0H7.948a1.997 1.997 0 0 0-1.997 1.999v23.446c0 1.102.892 1.997 1.997 1.997h11.546a2 2 0 0 0 1.997-1.997V1.999A2 2 0 0 0 19.494 0m-8.622 1.214h5.7c.144 0 .261.215.261.481s-.117.482-.261.482h-5.7c-.145 0-.26-.216-.26-.482s.115-.481.26-.481m2.85 24.255a1.275 1.275 0 1 1 0-2.55 1.275 1.275 0 0 1 0 2.55m6.273-4.369H7.448V3.373h12.547z" })), Ze = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, "aria-hidden": "true", "data-icon": "play-circle", "data-prefix": "far", viewBox: "0 0 512 512", ...e }, /* @__PURE__ */ a.createElement("path", { fill: "currentColor", d: "m371.7 238-176-107c-15.8-8.8-35.7 2.5-35.7 21v208c0 18.4 19.8 29.8 35.7 21l176-101c16.4-9.1 16.4-32.8 0-42M504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248m-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256" })), Qe = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 476.91 476.909", ...e }, /* @__PURE__ */ a.createElement("path", { d: "M62.802 142.287h121.682c4.45 0 10.95-3.805 13.32-7.999l24.816-41.066H62.802C28.12 93.222 0 121.342 0 156.026v20.779c13.266-20.719 36.425-34.518 62.802-34.518" }), /* @__PURE__ */ a.createElement("path", { d: "M414.105 67.708H266.913c-8.681 0-19.151 6.125-23.399 13.685l-7.147 11.828-28.489 47.157c-4.246 7.558-14.719 13.684-23.393 13.684H62.802C28.12 154.062 0 182.183 0 216.865v129.531c0 34.685 28.12 62.805 62.802 62.805h351.303c34.685 0 62.805-28.12 62.805-62.805V130.511c0-34.682-28.12-62.803-62.805-62.803M208.372 335.332h163.952a7.85 7.85 0 0 1 7.851 7.851 7.84 7.84 0 0 1-7.851 7.851H208.372a7.845 7.845 0 0 1-7.851-7.851 7.854 7.854 0 0 1 7.851-7.851m-7.851-33.57a7.85 7.85 0 0 1 7.851-7.851h163.952a7.843 7.843 0 0 1 7.851 7.851 7.845 7.845 0 0 1-7.851 7.851H208.372a7.85 7.85 0 0 1-7.851-7.851M380.19 216.52c0 4.332-3.526 7.851-7.85 7.851H250.659c-4.332 0-7.847-3.519-7.847-7.851 0-4.334 3.515-7.851 7.847-7.851H372.34c4.324 0 7.85 3.517 7.85 7.851m-7.85 35.971a7.85 7.85 0 0 1 7.85 7.85c0 4.341-3.526 7.852-7.85 7.852H208.372a7.85 7.85 0 0 1-7.851-7.852 7.845 7.845 0 0 1 7.851-7.85zm-243.722 52.846c10.395-6.052 21.512-8.007 30.413-6.288v-97.128h52.481a6.897 6.897 0 0 1 6.899 6.899v15.409a6.9 6.9 0 0 1-6.899 6.901h-35.53v87.636h-.088c-.571 10.552-8.752 22.466-21.919 30.132-17.829 10.379-37.956 9.028-44.955-2.989-7.003-12.031 1.771-30.193 19.598-40.572" })), qe = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", "aria-hidden": "true", "data-icon": "plus-circle", "data-prefix": "fas", viewBox: "0 0 512 512", ...e }, /* @__PURE__ */ a.createElement("path", { d: "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8m144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12z" })), Je = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, "aria-hidden": "true", viewBox: "0 0 448 512", ...e }, /* @__PURE__ */ a.createElement("path", { fill: "currentColor", d: "M267.429 488.563C262.286 507.573 242.858 512 224 512c-18.857 0-38.286-4.427-43.428-23.437C172.927 460.134 160 388.898 160 355.75c0-35.156 31.142-43.75 64-43.75s64 8.594 64 43.75c0 32.949-12.871 104.179-20.571 132.813M156.867 288.554c-18.693-18.308-29.958-44.173-28.784-72.599 2.054-49.724 42.395-89.956 92.124-91.881C274.862 121.958 320 165.807 320 220c0 26.827-11.064 51.116-28.866 68.552-2.675 2.62-2.401 6.986.628 9.187 9.312 6.765 16.46 15.343 21.234 25.363 1.741 3.654 6.497 4.66 9.449 1.891 28.826-27.043 46.553-65.783 45.511-108.565-1.855-76.206-63.595-138.208-139.793-140.369C146.869 73.753 80 139.215 80 220c0 41.361 17.532 78.7 45.55 104.989 2.953 2.771 7.711 1.77 9.453-1.887 4.774-10.021 11.923-18.598 21.235-25.363 3.029-2.2 3.304-6.566.629-9.185M224 0C100.204 0 0 100.185 0 224c0 89.992 52.602 165.647 125.739 201.408 4.333 2.118 9.267-1.544 8.535-6.31-2.382-15.512-4.342-30.946-5.406-44.339-.146-1.836-1.149-3.486-2.678-4.512-47.4-31.806-78.564-86.016-78.187-147.347.592-96.237 79.29-174.648 175.529-174.899C320.793 47.747 400 126.797 400 224c0 61.932-32.158 116.49-80.65 147.867-.999 14.037-3.069 30.588-5.624 47.23-.732 4.767 4.203 8.429 8.535 6.31C395.227 389.727 448 314.187 448 224 448 100.205 347.815 0 224 0m0 160c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64" })), Ke = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, "aria-hidden": "true", "data-icon": "step-backward", "data-prefix": "fas", viewBox: "0 0 448 512", ...e }, /* @__PURE__ */ a.createElement("path", { fill: "currentColor", d: "M64 468V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12v176.4l195.5-181C352.1 22.3 384 36.6 384 64v384c0 27.4-31.9 41.7-52.5 24.6L136 292.7V468c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12" })), e1 = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", ...e }, /* @__PURE__ */ a.createElement("path", { fill: "currentColor", d: "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512m-86.2-346.7c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1 0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6-13.3 0-24-10.7-24-24v-13.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1 0-8.4-6.8-15.1-15.1-15.1h-58.3c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1-64 0" })), t1 = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 652.49 128.17", ...e }, /* @__PURE__ */ a.createElement("path", { d: "M82.4 73.45a27.64 27.64 0 1 0-27.65 27.63A27.6 27.6 0 0 0 82.4 73.52zm-44.94 0a17.31 17.31 0 1 1 17.45 17.17h-.15a17.34 17.34 0 0 1-17.3-17.17m100.39 10.46H126a17.24 17.24 0 1 1 0-20.79h11.81a27.57 27.57 0 1 0 0 20.79zm144.48-38.09h-19.26V31.68h-10.33v14.14h-48.15a16.37 16.37 0 1 0-.81 32.73h23.34a6.1 6.1 0 0 1 6 6 6 6 0 0 1-6 6h-38.9V101h38.9a16.43 16.43 0 1 0 0-32.86h-22.53a6 6 0 1 1 0-12.07h48.15V101h10.33V56.15H272a32.66 32.66 0 0 1 10.33-10.33" }), /* @__PURE__ */ a.createElement("path", { d: "M299.66 45.82a27.63 27.63 0 0 0 0 55.26 28 28 0 0 0 17.31-6v6h10.33V73.45a27.6 27.6 0 0 0-27.57-27.63zm0 44.94A17.31 17.31 0 1 1 317 73.45a17.31 17.31 0 0 1-17.34 17.31m32.96-17.31v27.64h10.27V73.45c0-9.68 6.88-17.73 17.09-17.73v-9.91c-17.37 0-27.36 9.35-27.36 27.64M27.38 45.81C10 45.81 0 55.16 0 73.45v27.64h10.26V73.45c0-9.68 6.87-17.73 17.09-17.73zm157.8-.13h-13.14l-20.16 26.44V31.68h-10.32v69.4h10.32V74.51l20.16 26.44h13.14l-21.19-27.63zm248.67 27.94V101h-10.24v-6a27.7 27.7 0 0 1-17.15 6 27.39 27.39 0 1 1 27.39-27.39zm-10.24 0a17.15 17.15 0 1 0-17.15 17.15 17.19 17.19 0 0 0 17.15-17.15M448.48 101h-10.24V73.62a27.39 27.39 0 1 1 54.78 0V101h-10.24V73.62a17.15 17.15 0 1 0-34.3 0zm89.12-65.14h-10.37V25.62h10.37zm-10.37 10.37h10.37V101h-10.37zM542 73.62a27.39 27.39 0 0 1 52.79-10.24h-11.7a17.09 17.09 0 1 0 0 20.61h11.7A27.42 27.42 0 0 1 542 73.62m110.49-27.39v10.24h-38.56a6 6 0 1 0 0 12h22.33a16.29 16.29 0 0 1 0 32.58H597.7V90.64h38.56a6 6 0 0 0 6-6 6 6 0 0 0-6-6h-22.33a16.22 16.22 0 1 1 0-32.44z" }), /* @__PURE__ */ a.createElement("path", { d: "M521.87 45.86v10.26H513v44.93h-10.37V56.19h-8.93a32.86 32.86 0 0 0-10.33-10.33h19.26V31.71H513v14.15z" })), a1 = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, "aria-hidden": "true", "data-icon": "cog", "data-prefix": "fas", viewBox: "0 0 512 512", ...e }, /* @__PURE__ */ a.createElement("path", { fill: "currentColor", d: "m487.4 315.7-42.6-24.6c4.3-23.2 4.3-47 0-70.2l42.6-24.6c4.9-2.8 7.1-8.6 5.5-14-11.1-35.6-30-67.8-54.7-94.6-3.8-4.1-10-5.1-14.8-2.3L380.8 110c-17.9-15.4-38.5-27.3-60.8-35.1V25.8c0-5.6-3.9-10.5-9.4-11.7-36.7-8.2-74.3-7.8-109.2 0-5.5 1.2-9.4 6.1-9.4 11.7V75c-22.2 7.9-42.8 19.8-60.8 35.1L88.7 85.5c-4.9-2.8-11-1.9-14.8 2.3-24.7 26.7-43.6 58.9-54.7 94.6-1.7 5.4.6 11.2 5.5 14L67.3 221c-4.3 23.2-4.3 47 0 70.2l-42.6 24.6c-4.9 2.8-7.1 8.6-5.5 14 11.1 35.6 30 67.8 54.7 94.6 3.8 4.1 10 5.1 14.8 2.3l42.6-24.6c17.9 15.4 38.5 27.3 60.8 35.1v49.2c0 5.6 3.9 10.5 9.4 11.7 36.7 8.2 74.3 7.8 109.2 0 5.5-1.2 9.4-6.1 9.4-11.7v-49.2c22.2-7.9 42.8-19.8 60.8-35.1l42.6 24.6c4.9 2.8 11 1.9 14.8-2.3 24.7-26.7 43.6-58.9 54.7-94.6 1.5-5.5-.7-11.3-5.6-14.1M256 336c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80" })), r1 = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 512 512", ...e }, /* @__PURE__ */ a.createElement("path", { d: "M403.8 34.4c12-5 25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9S384 204.8 384 191.8V160h-32c-10.1 0-19.6 4.7-25.6 12.8L284 229.3 244 176l31.2-41.6C293.3 110.2 321.8 96 352 96h32V64c0-12.9 7.8-24.6 19.8-29.6M164 282.7l40 53.3-31.2 41.6C154.7 401.8 126.2 416 96 416H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h64c10.1 0 19.6-4.7 25.6-12.8zm274.6 188c-9.2 9.2-22.9 11.9-34.9 6.9S383.9 461 383.9 448v-32H352c-30.2 0-58.7-14.2-76.8-38.4L121.6 172.8c-6-8.1-15.5-12.8-25.6-12.8H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h64c30.2 0 58.7 14.2 76.8 38.4l153.6 204.8c6 8.1 15.5 12.8 25.6 12.8h32v-32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64z" })), s1 = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 512 512", ...e }, /* @__PURE__ */ a.createElement("path", { fill: "currentColor", d: "M400 128c0 44.4-25.4 83.5-64 106.4V256c0 17.7-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32v-21.6c-38.6-23-64-62.1-64-106.4C112 57.3 176.5 0 256 0s144 57.3 144 128m-200 48c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32m144-32c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32M35.4 273.7c7.9-15.8 27.1-22.2 42.9-14.3L256 348.2l177.7-88.8c15.8-7.9 35-1.5 42.9 14.3s1.5 35-14.3 42.9L327.6 384l134.8 67.4c15.8 7.9 22.2 27.1 14.3 42.9s-27.1 22.2-42.9 14.3L256 419.8 78.3 508.6c-15.8 7.9-35 1.5-42.9-14.3s-1.5-35 14.3-42.9L184.4 384 49.7 316.6c-15.8-7.9-22.2-27.1-14.3-42.9" })), c1 = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 217.928 217.928", ...e }, /* @__PURE__ */ a.createElement("path", { d: "M159.11 0H58.818C47.14 0 37.639 9.501 37.639 21.179v167.498c0 9.452 6.226 17.473 14.791 20.189v1.562a7.5 7.5 0 0 0 7.5 7.5h16.568a7.5 7.5 0 0 0 7.5-7.5v-.572h49.931v.572c0 4.143 3.357 7.5 7.5 7.5h16.569c4.143 0 7.5-3.357 7.5-7.5v-1.562c8.564-2.716 14.79-10.738 14.79-20.189V21.179C180.289 9.501 170.788 0 159.11 0m-50.146 79.841c-13.372 0-24.25-10.879-24.25-24.25s10.879-24.25 24.25-24.25 24.25 10.879 24.25 24.25-10.879 24.25-24.25 24.25m0 22.674c21.643 0 39.25 17.607 39.25 39.25s-17.607 39.25-39.25 39.25-39.25-17.607-39.25-39.25 17.608-39.25 39.25-39.25m18.75 39.25c0 10.339-8.411 18.75-18.75 18.75s-18.75-8.411-18.75-18.75 8.412-18.75 18.75-18.75 18.75 8.411 18.75 18.75m-5.72-86.174c0 7.185-5.845 13.03-13.029 13.03s-13.03-5.846-13.03-13.03 5.845-13.029 13.03-13.029 13.029 5.844 13.029 13.029" })), l1 = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 168 168", ...e }, /* @__PURE__ */ a.createElement("path", { fill: "currentColor", d: "M83.996.277C37.747.277.253 37.77.253 84.019c0 46.251 37.494 83.741 83.743 83.741 46.254 0 83.744-37.49 83.744-83.741 0-46.246-37.49-83.738-83.745-83.738zm38.404 120.78a5.217 5.217 0 0 1-7.18 1.73c-19.662-12.01-44.414-14.73-73.564-8.07a5.22 5.22 0 0 1-6.249-3.93 5.213 5.213 0 0 1 3.926-6.25c31.9-7.291 59.263-4.15 81.337 9.34 2.46 1.51 3.24 4.72 1.73 7.18m10.25-22.805c-1.89 3.075-5.91 4.045-8.98 2.155-22.51-13.839-56.823-17.846-83.448-9.764-3.453 1.043-7.1-.903-8.148-4.35a6.54 6.54 0 0 1 4.354-8.143c30.413-9.228 68.222-4.758 94.072 11.127 3.07 1.89 4.04 5.91 2.15 8.976zm.88-23.744c-26.99-16.031-71.52-17.505-97.289-9.684-4.138 1.255-8.514-1.081-9.768-5.219a7.835 7.835 0 0 1 5.221-9.771c29.581-8.98 78.756-7.245 109.83 11.202a7.823 7.823 0 0 1 2.74 10.733c-2.2 3.722-7.02 4.949-10.73 2.739z" })), n1 = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 577.608 577.608", ...e }, /* @__PURE__ */ a.createElement("path", { d: "M468.499 0H109.113C80.757 0 57.762 22.987 57.762 51.341v474.927c0 28.354 22.993 51.341 51.351 51.341h359.385c28.352 0 51.348-22.984 51.348-51.341V51.339C519.846 22.985 496.85 0 468.499 0M288.804 549.411c-12.146 0-22.038-9.861-22.038-22.047 0-12.164 9.892-22.044 22.038-22.044 12.165 0 22.057 9.88 22.057 22.044.001 12.186-9.892 22.047-22.057 22.047m186.124-77.483c0 6.187-5.023 11.197-11.205 11.197H113.887c-6.185 0-11.204-5.012-11.204-11.197V55.005c0-6.186 5.019-11.196 11.204-11.196h349.836c6.182 0 11.205 5.01 11.205 11.196z" })), d1 = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 489.25 489.25", ...e }, /* @__PURE__ */ a.createElement("path", { d: "M240.25 216.55c-4-1.1-8.1-1.7-12.4-1.7-25.7 0-46.6 20.9-46.6 46.6s20.9 46.6 46.6 46.6 46.6-20.9 46.6-46.6c0-4.3-.6-8.5-1.7-12.4l129.8-129.8 21 2.8 65.7-65.7-49.7-6.6-6.6-49.7-65.7 65.7 2.8 21z" }), /* @__PURE__ */ a.createElement("path", { d: "m232.85 171.95 38.4-38.4c-47.1-16-101.4-5.2-138.9 32.4-52.7 52.7-52.7 138.3 0 191s138.3 52.7 191 0c37.6-37.6 48.4-91.8 32.4-139l-38.4 38.4c1.4 24.6-7.3 49.7-26.1 68.5-35 35-91.8 35-126.8 0s-35-91.8 0-126.8c18.8-18.8 43.8-27.5 68.4-26.1" }), /* @__PURE__ */ a.createElement("path", { d: "M388.85 184.95c31.5 66.2 19.8 147.7-35 202.5-69.6 69.6-182.4 69.6-252 0s-69.6-182.4 0-252c54.8-54.8 136.3-66.4 202.5-35l36.7-36.7c-87-49.9-200-37.7-274.3 36.6-89 89-89 233.2 0 322.1 89 89 233.2 89 322.1 0 74.3-74.3 86.5-187.3 36.6-274.3z" })), i1 = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, "aria-hidden": "true", "data-icon": "trash", "data-prefix": "fas", viewBox: "0 0 448 512", ...e }, /* @__PURE__ */ a.createElement("path", { fill: "currentColor", d: "M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16M53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z" })), o1 = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 512 512", ...e }, /* @__PURE__ */ a.createElement("path", { d: "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7.2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8.2-40.1l216-368C228.7 39.5 241.8 32 256 32m0 128c-13.3 0-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24m32 224c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32" })), u1 = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ a.createElement("path", { d: "M24 4.557a9.8 9.8 0 0 1-2.828.775 4.93 4.93 0 0 0 2.165-2.724 9.9 9.9 0 0 1-3.127 1.195 4.92 4.92 0 0 0-3.594-1.555c-3.179 0-5.515 2.966-4.797 6.045A13.98 13.98 0 0 1 1.671 3.149a4.93 4.93 0 0 0 1.523 6.574 4.9 4.9 0 0 1-2.229-.616c-.054 2.281 1.581 4.415 3.949 4.89a4.9 4.9 0 0 1-2.224.084 4.93 4.93 0 0 0 4.6 3.419A9.9 9.9 0 0 1 0 19.54a13.94 13.94 0 0 0 7.548 2.212c9.142 0 14.307-7.721 13.995-14.646A10 10 0 0 0 24 4.557" })), H = (e) => /* @__PURE__ */ a.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", viewBox: "0 0 576 512", ...e }, /* @__PURE__ */ a.createElement("path", { fill: "currentColor", d: "M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305m-317.51 213.508V175.185l142.739 81.205z" })), h1 = "https://go.rockstar.bingo/contact-us", m1 = "https://www.facebook.com/groups/rockstar.bingo.hosts", g1 = "https://help.rockstar.bingo", f1 = "http://musicbingopodcast.com", b1 = "https://www.youtube.com/channel/UCb87IPx_mdEQC7WCq9M9n4A", U = 75, F = {
  blue: "bg-blue-500 border-blue-400 dark:border-blue-600 text-white",
  default: "bg-shade-2 border-blue-500",
  green: "bg-green-500 border-green-400 dark:border-green-600 text-white",
  orange: "bg-orange-500 border-orange-400 dark:border-orange-600 text-black",
  pink: "bg-pink-500 border-pink-400 dark:border-pink-600 text-white",
  purple: "bg-purple-500 border-purple-400 dark:border-purple-600 text-white",
  red: "bg-red-500 border-red-400 dark:border-red-600 text-white",
  teal: "bg-teal-500 border-teal-400 dark:border-teal-600 text-white",
  yellow: "bg-yellow-500 border-yellow-400 dark:border-yellow-600 text-black"
}, D = {
  large: "w-20 h-12 rounded-2xl font-semibold text-base sm:text-xl pb-1",
  medium: "w-12 h-8 rounded-lg text-sm sm:text-base font-extrabold pb-[0.20rem]",
  small: "w-12 h-6 rounded-md text-xs sm:text-sm font-bold pb-0.5"
}, E = O.forwardRef(
  ({ children: e, className: r, colour: s = "default", size: c = "medium" }, n) => /* @__PURE__ */ t(
    "span",
    {
      className: d(
        "inline-flex items-center justify-center border-2 px-2 uppercase",
        F[s],
        D[c],
        r
      ),
      ref: n,
      children: e
    }
  )
);
E.displayName = "Badge";
function B({ children: e, className: r }) {
  return /* @__PURE__ */ t("div", { className: d("grid grid-cols-5 gap-1", r), children: e });
}
function M({ children: e, className: r, ...s }) {
  return /* @__PURE__ */ t(
    "div",
    {
      className: d(
        "relative flex flex-col items-center justify-center overflow-hidden rounded-lg p-1.5",
        "bg-shade-0 text-default",
        "select-none text-center text-base",
        "transition-all duration-300 ease-in-out",
        "opacity-[--square-opacity]",
        r
      ),
      ...s,
      children: e
    }
  );
}
function X({ children: e, className: r }) {
  return /* @__PURE__ */ t(
    "div",
    {
      className: d(
        "m-auto grid h-full w-full gap-1 p-1",
        "text-xs md:text-lg lg:text-xl",
        r
      ),
      children: e
    }
  );
}
const W = ["B", "I", "N", "G", "O"];
function $({
  currentDrawnItem: e,
  currentDrawnItemIndex: r,
  shouldHighlightSetting: s
}) {
  const c = (n) => !s || r === null ? !1 : n === (e == null ? void 0 : e.column);
  return /* @__PURE__ */ t(B, { className: "bingo-card-header", children: W.map((n, i) => /* @__PURE__ */ t(
    M,
    {
      className: d("bingo-card-header-square pb-2 text-xl font-extrabold", {
        "column-active bg-orange-500 text-black": c(i)
      }),
      children: n
    },
    `card-header--${i}`
  )) });
}
function Y({ artist: e, disableArtist: r, title: s }) {
  return /* @__PURE__ */ l("div", { className: "whitespace-break-spaces break-words", children: [
    /* @__PURE__ */ t(Q, { children: s }),
    !r && /* @__PURE__ */ t(Z, { children: e })
  ] });
}
function Z({ children: e }) {
  return /* @__PURE__ */ t("div", { className: "bingo-card-square-subtitle", children: e });
}
function Q({ children: e }) {
  return /* @__PURE__ */ t("div", { className: "bingo-card-square-title", children: e });
}
function q({ id: e }) {
  return /* @__PURE__ */ t("div", { className: "bingo-card-square-number", children: /* @__PURE__ */ t("span", { children: e }) });
}
const J = "absolute bottom-5 right-1 -mb-4 mt-4";
function L({ children: e, className: r, isAbsolute: s = !0 }) {
  return /* @__PURE__ */ t(
    "div",
    {
      className: N(
        "flex h-4 w-4 items-center rounded-full bg-[#616161] p-1 text-white",
        { [J]: s },
        r
      ),
      children: e
    }
  );
}
function K({ answer: e }) {
  return /* @__PURE__ */ t("div", { className: "whitespace-break-spaces break-words", children: /* @__PURE__ */ t(ee, { children: e }) });
}
function ee({ children: e }) {
  return /* @__PURE__ */ t("div", { className: "bingo-card-square-title", children: e });
}
function te({ correct: e }) {
  return /* @__PURE__ */ t(
    M,
    {
      className: d(
        "bingo-card-square",
        "bingo-card-square-free",
        "daubed",
        "bg-blue-500 text-2xl font-extrabold text-white",
        {
          "bg-green-500 text-white": e
        }
      ),
      children: /* @__PURE__ */ t("span", { children: "FREE" })
    },
    "free-space"
  );
}
function ae({
  columnIndex: e,
  onSquareClick: r,
  square: s,
  squareIndex: c
}) {
  if (s.type === "free")
    return /* @__PURE__ */ t(te, { correct: !!s.correct });
  const { correct: n, correctMissed: i, daubed: h, id: m, incorrect: g } = s;
  return /* @__PURE__ */ l(
    M,
    {
      className: d(
        "bingo-card-square",
        {
          correct: n,
          "correct-missed": i,
          daubed: h,
          incorrect: g
        },
        { "border-blue-500 bg-blue-500 text-white": h },
        { "border-green-500 bg-green-500 text-white": n }
      ),
      onClick: () => r == null ? void 0 : r(e, c),
      children: [
        s.type === "music" && /* @__PURE__ */ t(Y, { ...s }),
        s.type === "trivia" && /* @__PURE__ */ t(K, { ...s }),
        s.type === "numbers" && /* @__PURE__ */ t(q, { ...s }),
        i && /* @__PURE__ */ t(L, { className: N({ "bg-green-500": h }), children: /* @__PURE__ */ t(_, {}) }),
        g && /* @__PURE__ */ t(L, { className: "bg-red-500", children: /* @__PURE__ */ t(T, {}) })
      ]
    },
    m.toString()
  );
}
function re({
  columnIndex: e,
  currentDrawnItemIndex: r,
  drawnItems: s,
  onSquareClick: c,
  shouldHighlightSetting: n,
  squares: i
}) {
  return /* @__PURE__ */ t(
    "div",
    {
      className: d("bingo-card-column", "grid grid-rows-5 gap-1", "group", {
        "column-active": !n || r === null ? !1 : s[r].column === e
      }),
      children: i.map((m, g) => /* @__PURE__ */ t(
        ae,
        {
          columnIndex: e,
          square: m,
          squareIndex: g,
          onSquareClick: c
        },
        `square--${g}`
      ))
    }
  );
}
function v1({
  currentPlayerHasCalledBingo: e = !1,
  gameData: r,
  onSquareClick: s,
  playerData: c
}) {
  if (!c || !r) return null;
  const { playerCard: n } = c;
  if (!n) return null;
  const { currentItemIndex: i, drawnItems: h } = r, m = Object.values(n).map(
    (b) => b.map((u) => r.type === "music" ? { ...u, disableArtist: r.disableArtist } : u)
  ), g = () => {
    if (i !== null)
      return h[i];
  };
  return /* @__PURE__ */ t("div", { className: "bingo-card-container", children: /* @__PURE__ */ l(
    X,
    {
      className: N("bingo-card", {
        "has-bingo": e,
        "highlighting-disabled": !r.highlightColumns
      }),
      children: [
        /* @__PURE__ */ t(
          $,
          {
            currentDrawnItem: g(),
            currentDrawnItemIndex: i,
            shouldHighlightSetting: r.highlightColumns
          }
        ),
        /* @__PURE__ */ t(B, { children: m.map((b, u) => /* @__PURE__ */ t(
          re,
          {
            columnIndex: u,
            currentDrawnItemIndex: i,
            drawnItems: h,
            shouldHighlightSetting: r.highlightColumns,
            squares: b,
            onSquareClick: s
          },
          `column--${u}`
        )) })
      ]
    }
  ) });
}
var f = /* @__PURE__ */ ((e) => (e[e.B = 0] = "B", e[e.I = 1] = "I", e[e.N = 2] = "N", e[e.G = 3] = "G", e[e.O = 4] = "O", e))(f || {}), o = /* @__PURE__ */ ((e) => (e.ONE_LINE = "one_line", e.TWO_LINES = "two_lines", e.THREE_LINES = "three_lines", e.FOUR_LINES = "four_lines", e.FULL_CARD = "full_card", e.CORNERS = "corners", e.EDGES = "edges", e.X_SHAPE = "x_shape", e))(o || {});
function se(e, r) {
  return r.some((s) => s.id === e.id) && !e.correct;
}
function ce(e, r) {
  return !!(e.daubed && !r.some((s) => s.id === e.id) && !e.correct);
}
const w1 = (e, r) => {
  let s = 0, c = 0;
  if (!e) return { ...r, correctCount: c };
  const { currentItemIndex: n, drawnItems: i } = e;
  if (!n) return { ...r, correctCount: c };
  const { playerCard: h } = r, m = (u, w) => {
    const v = se(u, w), y = ce(u, w), { correct: C } = u;
    return v && s++, C && c++, {
      ...u,
      correctMissed: v,
      incorrect: y
    };
  }, g = i.filter((u, w) => w <= n), b = {
    [f.B]: h[f.B].map((u) => m(u, g)),
    [f.I]: h[f.I].map((u) => m(u, g)),
    [f.N]: h[f.N].map((u) => m(u, g)),
    [f.G]: h[f.G].map((u) => m(u, g)),
    [f.O]: h[f.O].map((u) => m(u, g))
  };
  return {
    ...r,
    correctCount: c + s,
    playerCard: b
  };
};
function le({ children: e }) {
  return /* @__PURE__ */ t("div", { className: "grid grid-cols-[repeat(auto-fill,minmax(340px,1fr))] gap-4", children: e });
}
le.Item = function({
  children: r,
  playerName: s
}) {
  return /* @__PURE__ */ t("div", { className: "flex flex-1 flex-col justify-center gap-2 rounded-xl bg-shade-1 text-center", children: /* @__PURE__ */ t("div", { className: "flex aspect-square w-full flex-1 flex-col", children: /* @__PURE__ */ l("div", { className: "flex flex-1 flex-col", children: [
    s && /* @__PURE__ */ t(S, { className: "my-2", size: "small", children: s }),
    r
  ] }) }) });
};
function p1({
  children: e,
  className: r,
  id: s,
  isChecked: c,
  isDisabled: n,
  name: i,
  onChange: h
}) {
  return /* @__PURE__ */ l(
    "div",
    {
      className: d(
        "checkbox bounce relative flex items-center transition-opacity duration-300 ease-in-out",
        {
          "opacity-66": n
        },
        r
      ),
      children: [
        /* @__PURE__ */ t(
          "input",
          {
            checked: c,
            className: "relative m-0 size-6 appearance-none rounded outline-none transition-all duration-300",
            disabled: n,
            id: s,
            name: i,
            type: "checkbox",
            onChange: h
          }
        ),
        /* @__PURE__ */ t(R, {}),
        e && /* @__PURE__ */ t(
          "label",
          {
            className: "ml-2 flex cursor-pointer items-center leading-tight transition-colors duration-300 ease-in-out",
            htmlFor: s,
            children: e
          }
        )
      ]
    }
  );
}
const ne = [
  {
    description: "Rockstar Bingo generates unique game codes that guests use to enter the game lobby. As the host, you admit the guests, who will then automatically receive an electronic bingo card on their device.",
    id: "cards",
    title: "Generate digital music bingo cards (no printing ever)"
  },
  {
    description: "Guests can access Rockstar Bingo cards from any device with an internet connection and a web browser. Typically hosts will use a laptop or tablet while guests usually connect with the game controller already in their pocket or purse - their smart phones.",
    id: "any-device",
    title: "Play games on any device"
  },
  {
    description: `Import playlists from Spotify, or upload a spreadsheet. Note that playlists must have at least ${U} songs to be compatible with our system - we call this "bingo math".`,
    id: "own-playlists",
    title: "Use your own playlists"
  },
  {
    description: "Connect to Spotify and import your favourite playlists. During gameplay, Rockstar Bingo can control your Spotify device so that playback is in sync with the game.",
    id: "music-services",
    title: "Integrate with Spotify Premium"
  },
  {
    description: "Enhance your hosting experience by using multiple devices simultaneously. Set up the game on your laptop or tablet while using your phone as a remote control, allowing you to move freely around the room. This setup offers flexibility and convenience for dynamic hosting.",
    id: "host-multiple-devices",
    title: "Host with one device or many"
  },
  {
    description: "Offer your guests a variety of exciting patterns to aim for, including one line, two lines, X, four corners, full card, and more. Keep your guests engaged and entertained throughout the entire event.",
    id: "customize-targets",
    title: "Many targets to choose from",
    videoUrl: "https://youtu.be/exX_zyiuYN4"
  },
  {
    description: "Hosts can choose to collect contact information from winning guests within the app (after a successful bingo is called). This is useful for scenarios where guests aren't local/on-site such as games hosts via Zoom, Microsoft Teams, WebEx, Twitch, etc., for large venues such as sporting events and even radio broadcasts.",
    id: "winner-contact",
    title: "Collect winner contact details"
  },
  {
    description: "Add your logo, custom messaging, and call to action link to your music bingo card guest experience. Custom join experiences are also available.",
    id: "branding",
    title: "Custom branding and calls to action"
  },
  {
    description: "Personalize your bingo game experience by customizing song and artist titles, along with Spotify start positions and other key details.",
    id: "customize-playlists",
    title: "Customize playlists"
  },
  {
    description: "Our bingo games allow you to play songs in a specific order, making it an excellent option for bands and performers to use as a setlist.",
    id: "customize-setlists",
    title: "Customize setlists"
  },
  {
    description: "Easily monitor your game history and guest attendance by venue, and showcase the success of your events to those who hired you.",
    id: "reporting",
    title: "Game history with stats"
  },
  {
    description: "Elevate the production value of your event by showcasing videos on secondary screens (online or onsite via screen casting to TV's) using YouTube and Vimeo videos as the source content. Hosts can provide a pre-game video (useful for promotions, instructions, etc. before a game starts), a default video (typically a fun/engaging video for visual excitement throughout the game). Videos can also be provided as visual enhancements per song, if desired).",
    id: "jumbotron",
    title: "Jumbotron view",
    videoUrl: "https://www.youtube.com/watch?v=9PnCSxrlCNA"
  },
  {
    description: "Hosts can share a 'sidekick view' with one or more co-hosts. Co-Hosts can assist with managing the lobby and features such as lyrics (from Genius), BPM (tempo) and key signatures which empower bands, duos and musicians to deliver Music Bingo with live music!",
    id: "sidekick",
    title: "Sidekick view"
  },
  {
    description: "Enjoy the classic experience of traditional numbers bingo, where numbers are called out and players mark them off on their cards. This familiar game format is perfect for those who love the simplicity and excitement of standard bingo.",
    id: "numbers-bingo",
    title: "Traditional Numbers Bingo"
  },
  {
    description: "Easily expand your game capacity by adding seats to your account at any time, even during an active game. This flexibility ensures that you can accommodate additional guests without any disruption, making your events more inclusive.",
    id: "add-seats",
    title: "Add seats anytime (even during a game)"
  },
  {
    description: "Enjoy unlimited hosting capabilities with our affordable pricing. Host as many games as you want without worrying about additional costs, making it easy to entertain and engage your audience anytime.",
    id: "unlimited-games",
    title: "Unlimited games for one low price"
  }
];
function z({
  InfoTooltip: e,
  className: r,
  showDescription: s = !1
}) {
  return /* @__PURE__ */ t("ul", { className: d("flex flex-col gap-6", r), children: ne.map((c) => /* @__PURE__ */ t(
    z.Item,
    {
      InfoTooltip: e,
      description: c.description,
      isProOnly: c.isProOnly,
      showDescription: s,
      title: c.title,
      videoUrl: c.videoUrl
    },
    c.id
  )) });
}
z.Item = ({
  InfoTooltip: e,
  description: r,
  isProOnly: s,
  showDescription: c = !1,
  title: n,
  videoUrl: i
}) => /* @__PURE__ */ t(V, { children: /* @__PURE__ */ l("li", { className: "group relative flex w-full flex-col gap-2", children: [
  /* @__PURE__ */ l("div", { className: "flex w-full items-center gap-4", children: [
    /* @__PURE__ */ l("div", { className: "flex w-16 justify-end", children: [
      !s && /* @__PURE__ */ t(j, { className: "text-green-500" }),
      s && /* @__PURE__ */ t(E, { className: "w-auto text-xs", colour: "pink", size: "small", children: "Pro" })
    ] }),
    /* @__PURE__ */ t(S, { className: "w-full whitespace-normal", children: n }),
    !c && /* @__PURE__ */ l("div", { className: "flex w-24 justify-end gap-4 opacity-0 transition-opacity duration-300 group-hover:opacity-100", children: [
      i && /* @__PURE__ */ t("a", { href: i, rel: "noreferrer", target: "_blank", children: /* @__PURE__ */ t("span", { className: "text-muted", children: /* @__PURE__ */ t(H, { className: "size-6" }) }) }),
      e && /* @__PURE__ */ t(e, { children: r })
    ] })
  ] }),
  c && /* @__PURE__ */ l("div", { className: "flex w-full gap-4", children: [
    /* @__PURE__ */ t("div", { className: "flex w-16" }),
    /* @__PURE__ */ l("div", { className: "flex w-full flex-col gap-4", children: [
      /* @__PURE__ */ t(k, { className: "w-full text-base", children: r }),
      i && /* @__PURE__ */ l(
        "a",
        {
          className: "flex items-center gap-2 text-red-500",
          href: i,
          rel: "noreferrer",
          target: "_blank",
          children: [
            /* @__PURE__ */ t("span", { className: "text-sm font-bold uppercase", children: "Watch Video" }),
            /* @__PURE__ */ t("span", { className: "text-red-500", children: /* @__PURE__ */ t(H, { className: "size-6" }) })
          ]
        }
      )
    ] })
  ] })
] }) });
function x1({ children: e }) {
  return /* @__PURE__ */ t("div", { className: "flex flex-1 flex-col text-white", children: /* @__PURE__ */ t("div", { className: "flex flex-1 flex-col bg-purple-900 bg-game bg-right-bottom bg-no-repeat", children: e }) });
}
function E1({ children: e, className: r, ...s }) {
  return /* @__PURE__ */ t(
    "label",
    {
      className: d(
        "flex items-center justify-between text-sm font-semibold uppercase tracking-tight text-muted",
        r
      ),
      ...s,
      children: e
    }
  );
}
const de = "[&>*]:first-of-type:rounded-t-lg [&>*]:last-of-type:rounded-b-lg", ie = {
  default: "[&>*]:first-of-type:border-t [&>*]:last-of-type:border-b",
  disabled: "[&>*]:border-x-0 [&>*]:last-of-type:border-b-0"
}, x = [
  "relative",
  "group w-full flex items-center justify-between gap-2 overflow-hidden",
  "border border-t-0 border-shade-3",
  "bg-shade-0 hover:bg-shade-2 dark:bg-shade-1 dark:hover:bg-shade-3",
  "transition-colors duration-300 ease-in-out",
  "focus:outline-none focus-visible:outline-none",
  "focus-visible:ring-2 focus-visible:ring-purple-500 focus-visible:ring-inset",
  "p-4 md:px-6",
  "text-left"
];
function oe({ children: e, className: r, ...s }) {
  return /* @__PURE__ */ t(
    "ul",
    {
      ...s,
      className: d(
        "bg-shade-1 flex flex-col overflow-hidden",
        "focus:outline-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-500",
        "rounded-lg",
        r
      ),
      children: e
    }
  );
}
const ue = P(
  ({
    LinkComponent: e,
    actions: r,
    actionsPosition: s = "static",
    children: c,
    className: n,
    disableBorder: i,
    disableRadiusBottom: h,
    disableRadiusTop: m,
    isSelected: g = !1,
    onClick: b,
    showActionsOnHover: u = !1,
    showChevron: w,
    to: v,
    ...y
  }, C) => {
    const A = i ? "disabled" : "default", p = /* @__PURE__ */ l(V, { children: [
      /* @__PURE__ */ t("div", { className: "flex flex-1 overflow-hidden", children: c }),
      r && /* @__PURE__ */ t(he, { position: s, showOnHover: u, children: r }),
      w && /* @__PURE__ */ t(me, {})
    ] });
    return /* @__PURE__ */ l(
      "li",
      {
        ...y,
        className: d(
          "flex",
          de,
          ie[A],
          { "[&>*]:last-of-type:rounded-b-none": h },
          { "[&>*]:first-of-type:rounded-t-none": m },
          n
        ),
        ref: C,
        children: [
          b && !v && /* @__PURE__ */ t("button", { className: d(x, n), type: "button", onClick: b, children: p }),
          v && e && /* @__PURE__ */ t(e, { className: d(x, n), href: v, children: p }),
          v && !e && /* @__PURE__ */ t("a", { className: d(x, n), href: v, children: p }),
          !v && !b && /* @__PURE__ */ t("div", { className: d(x, n), children: p })
        ]
      }
    );
  }
);
oe.Item = ue;
function he({ children: e, position: r, showOnHover: s }) {
  return /* @__PURE__ */ t(
    "div",
    {
      className: d(
        "duration-600 flex h-full items-center justify-center transition-opacity ease-in-out",
        "group-hover:visible group-hover:opacity-100",
        "group-focus-visible:ring-0",
        { "sm:invisible sm:opacity-0": s },
        { "absolute right-4": r === "absolute" }
      ),
      children: e
    }
  );
}
function me() {
  return /* @__PURE__ */ t("div", { className: "flex items-center justify-end", children: /* @__PURE__ */ t(G, { className: "mr-[-0.10rem] size-4" }) });
}
function y1({ className: e, size: r = "large" }) {
  return /* @__PURE__ */ l(
    "svg",
    {
      className: d("h-8", { "h-12": r === "large" }, e),
      viewBox: "0 0 764.2 128.2",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ t("defs", {}),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M396 48.4l16 15.7 22.9-1.9-19.4 17-3 18.4L437 82.5l25.6 17.2-8.1-31 25.8-19.4-33.4-3.1-9.9-31.5-8.5 26.5-1 3.3z",
            fill: "#fff"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M82.4 73.5c0-15.3-12.3-27.6-27.6-27.6S27.2 58.2 27.2 73.5c0 15.2 12.3 27.6 27.6 27.6s27.6-12.5 27.6-27.6zm-44.9 0c0-9.5 7.8-17.3 17.3-17.3S72.1 64 72.1 73.5s-7.8 17.2-17.3 17.2c-9.6-.1-17.3-7.7-17.3-17.2zM137.8 83.9H126c-3.1 4.2-8.2 6.8-13.8 6.8-9.5 0-17.2-7.8-17.2-17.3s7.6-17.2 17.2-17.2c5.6 0 10.7 2.7 13.8 6.8h11.8c-4-10.1-14-17.3-25.6-17.3-15.2 0-27.6 12.5-27.6 27.6 0 15.3 12.5 27.6 27.6 27.6 11.7.2 21.6-6.9 25.6-17zM282.3 45.8H263V31.7h-10.3v14.1H204.5c-9 0-16.4 7.2-16.4 16.4 0 9 7.4 16.4 16.4 16.4H227c3.4 0 6 2.8 6 6 0 3.4-2.7 6-6 6h-38.9v10.5H227c9 0 16.4-7.4 16.4-16.5 0-9-7.4-16.4-16.4-16.4h-22.5c-3.4 0-6-2.7-6-6 0-3.4 2.7-6 6-6h48.2v44.9H263v-45h8.9c2.7-4.1 6.3-7.7 10.4-10.3z",
            fill: "var(--text)"
          }
        ),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M299.7 45.8c-15.3 0-27.6 12.3-27.6 27.6s12.3 27.6 27.6 27.6c6.6 0 12.5-2.3 17.3-6v6h10.3V73.5c0-15.3-12.3-27.7-27.6-27.7zm0 45c-9.5 0-17.3-7.8-17.3-17.3s7.8-17.3 17.3-17.3S317 63.9 317 73.5s-7.8 17.3-17.3 17.3zM332.6 73.4V101h10.3V73.4c0-9.7 6.9-17.7 17.1-17.7v-9.9c-17.4 0-27.4 9.4-27.4 27.6zM27.4 45.8C10 45.8 0 55.2 0 73.4V101h10.3V73.4c0-9.7 6.9-17.7 17.1-17.7v-9.9zM185.2 45.7H172l-20.1 26.4V31.7h-10.3v69.4h10.3V74.5L172 101h13.2L164 73.3z",
            fill: "var(--text)"
          }
        ),
        /* @__PURE__ */ t("g", { fill: "var(--text)", children: /* @__PURE__ */ t("path", { d: "M569.7 73.5c0 15.1-12.2 27.3-27.3 27.3-15 0-27.3-12.2-27.3-27.3V18.8h10.4v33.4c4.6-3.8 10.6-6.1 17-6.1 15 .1 27.2 12.4 27.2 27.4zm-10.2 0c0-9.4-7.7-17-17.1-17-9.4 0-17 7.6-17 17s7.6 17.1 17 17.1 17.1-7.7 17.1-17.1zM585.2 35.8h-10.4V25.6h10.4v10.2zm-10.3 10.4h10.4v54.7h-10.4V46.2zM602 100.8h-10.2V73.5c0-15.1 12.2-27.3 27.3-27.3 15.1 0 27.3 12.2 27.3 27.3v27.3h-10.2V73.5c0-9.4-7.7-17.1-17.1-17.1-9.4 0-17.1 7.7-17.1 17.1v27.3zM695.1 100.7v-6c-4.6 3.8-10.6 6.1-17.1 6.1-15 0-27.3-12.3-27.3-27.3 0-15.1 12.3-27.3 27.3-27.3 15.1 0 27.3 12.2 27.3 27.3v27.3c0 15-12.2 27.3-27.3 27.3-12.7 0-23.4-8.8-26.4-20.6h10.7c2.7 6 8.8 10.2 15.7 10.2 9.4 0 17.1-7.6 17.1-17zm0-27.2c0-9.4-7.7-17.1-17.1-17.1-9.4 0-17 7.7-17 17.1 0 9.4 7.6 17 17 17s17.1-7.6 17.1-17zM764.2 73.5c0 15-12.2 27.3-27.3 27.3-15.1 0-27.3-12.3-27.3-27.3 0-15.1 12.2-27.3 27.3-27.3 15.1 0 27.3 12.2 27.3 27.3zm-10.3 0c0-9.4-7.7-17.1-17.1-17.1-9.4 0-17.1 7.7-17.1 17.1 0 9.4 7.7 17 17.1 17 9.4 0 17.1-7.6 17.1-17z" }) }),
        /* @__PURE__ */ t(
          "path",
          {
            d: "M437 25.1l1.5 4.5 3.5 10.6 3.4 10.4h26.8l-3.8 2.8-9 6.6-8.8 6.5 3.4 10.4 3.4 10.6 1.5 4.5-3.9-2.8-9-6.5-8.9-6.4-8.9 6.4-9 6.5-3.9 2.8 1.5-4.5 1.9-5.9.2-.5.4-.3 5-3.6 11.9-8.6.9-.7.9.7 8.1 5.8-3-9.5-.3-1.1.9-.7 8-5.9h-11l-.4-1.1-3.1-9.4-3.1 9.4-.4 1.1h-22.5l-.4-.3-4.9-3.6-3.8-2.8H428.9l3.4-10.4 3.5-10.6 1.2-4.4M437 0l-7.4 22.7-1.5 4.5-3.5 10.6-1.6 5h-21.2l-23.8.1L397.3 57l3.8 2.8 4.9 3.6.4.3 2.1 1.5h19l-7.9 5.7-5 3.6-.4.3-2.1 1.5-.8 2.4-.2.5-1.9 5.9-1.5 4.5-7.3 22.7 19.3-14 3.9-2.8 9-6.5 4.3-3.1 4.3 3.1 9 6.5 3.9 2.8 19.3 14-7.3-22.7-1.5-4.5-3.4-10.6-1.6-5 4.3-3.1 9-6.6 3.8-2.8L496 42.9l-23.9-.1h-21.2l-1.6-5-3.5-10.6-1.5-4.5L437 0z",
            fill: "#6A24DB"
          }
        )
      ]
    }
  );
}
const ge = {
  green: "bg-green-500 text-white",
  orange: "bg-orange-500 text-black",
  red: "bg-red-500 text-white"
};
function C1({ children: e, className: r, color: s = "orange" }) {
  return /* @__PURE__ */ t(
    "div",
    {
      className: d(
        "flex h-16 w-full items-center justify-center rounded-lg px-6 font-semibold uppercase",
        ge[s],
        r
      ),
      children: e
    }
  );
}
function I({ children: e, className: r, disablePadding: s = !1 }) {
  return /* @__PURE__ */ t(
    "div",
    {
      className: d(
        "flex flex-1 flex-col rounded-lg border border-shade-4 bg-shade-0 text-default shadow-xl dark:border-shade-3 dark:bg-shade-1",
        { "p-4 md:p-6 lg:p-8": !s },
        r
      ),
      children: e
    }
  );
}
I.Graphic = function({ children: e, className: r }) {
  return /* @__PURE__ */ t(
    "div",
    {
      className: d(
        "m-auto inline-flex h-24 w-24 items-center justify-center rounded-full p-10",
        r
      ),
      children: e
    }
  );
};
I.Header = function({ children: e, className: r }) {
  return /* @__PURE__ */ l(
    "header",
    {
      className: d(
        "relative flex w-full items-center justify-center overflow-hidden rounded-t-lg p-5 md:-mb-5 md:p-10 [&>*]:z-10",
        r
      ),
      children: [
        /* @__PURE__ */ t(be, { className: "bg-shade-0 dark:bg-shade-1" }),
        e
      ]
    }
  );
};
I.Body = function({ children: e, className: r }) {
  return /* @__PURE__ */ t("div", { className: d("w-full flex-1 overflow-hidden p-4 md:p-6 lg:p-8", r), children: e });
};
function fe({ rank: e, rankTied: r }) {
  return /* @__PURE__ */ l(E, { className: "shrink-0", colour: e === 1 ? "pink" : void 0, children: [
    r && /* @__PURE__ */ t("span", { children: "T-" }),
    e
  ] });
}
function S1({ children: e }) {
  return /* @__PURE__ */ l("div", { className: "flex max-w-full flex-col gap-6 overflow-hidden", children: [
    /* @__PURE__ */ l("header", { className: "flex items-center justify-between overflow-hidden", children: [
      /* @__PURE__ */ t("h2", { className: "m-0 text-sm font-semibold uppercase tracking-tight", children: "Scoreboard" }),
      /* @__PURE__ */ t("div", { className: "m-0 flex w-16 justify-center", children: /* @__PURE__ */ t("h3", { className: "m-0 text-sm font-semibold uppercase tracking-tight", children: "Bingos" }) })
    ] }),
    /* @__PURE__ */ t("ul", { className: "flex flex-col gap-4 overflow-hidden text-xl", children: e })
  ] });
}
function N1({ bingoCount: e, playerName: r, rank: s, rankTied: c }) {
  return /* @__PURE__ */ l("div", { className: "flex max-w-full justify-between gap-2 overflow-hidden", children: [
    /* @__PURE__ */ l("div", { className: "flex max-w-full gap-2 overflow-hidden", children: [
      /* @__PURE__ */ t(fe, { rank: s, rankTied: c }),
      /* @__PURE__ */ t("div", { className: "flex w-full max-w-full items-center overflow-hidden truncate text-sm md:text-xl lg:text-2xl", children: /* @__PURE__ */ t("span", { className: "truncate", children: r }) })
    ] }),
    /* @__PURE__ */ t("div", { className: "flex w-16 justify-center", children: /* @__PURE__ */ t(E, { colour: "teal", children: e }) })
  ] });
}
function be({ className: e }) {
  return /* @__PURE__ */ t(
    "div",
    {
      className: d(
        "absolute bottom-[-150%] z-[1] h-[200%] w-[110%] skew-y-[10deg] bg-shade-0 dark:bg-shade-0",
        e
      )
    }
  );
}
function ve(e) {
  switch (e) {
    case o.ONE_LINE:
      return [
        [
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !1 }
        ],
        [{ daubed: !0 }, { daubed: !0 }, { daubed: !0 }, { daubed: !0 }, { daubed: !0 }],
        [
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !1 }
        ],
        [
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !1 }
        ],
        [
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !1 }
        ]
      ];
    case o.TWO_LINES:
      return [
        [
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !0 },
          { daubed: !1 }
        ],
        [{ daubed: !0 }, { daubed: !0 }, { daubed: !0 }, { daubed: !0 }, { daubed: !0 }],
        [
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !0 },
          { daubed: !1 }
        ],
        [
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !0 },
          { daubed: !1 }
        ],
        [
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !0 },
          { daubed: !1 }
        ]
      ];
    case o.THREE_LINES:
      return [
        [
          { daubed: !1 },
          { daubed: !0 },
          { daubed: !1 },
          { daubed: !0 },
          { daubed: !1 }
        ],
        [{ daubed: !0 }, { daubed: !0 }, { daubed: !0 }, { daubed: !0 }, { daubed: !0 }],
        [
          { daubed: !1 },
          { daubed: !0 },
          { daubed: !1 },
          { daubed: !0 },
          { daubed: !1 }
        ],
        [
          { daubed: !1 },
          { daubed: !0 },
          { daubed: !1 },
          { daubed: !0 },
          { daubed: !1 }
        ],
        [
          { daubed: !1 },
          { daubed: !0 },
          { daubed: !1 },
          { daubed: !0 },
          { daubed: !1 }
        ]
      ];
    case o.FOUR_LINES:
      return [
        [
          { daubed: !1 },
          { daubed: !0 },
          { daubed: !1 },
          { daubed: !0 },
          { daubed: !1 }
        ],
        [{ daubed: !0 }, { daubed: !0 }, { daubed: !0 }, { daubed: !0 }, { daubed: !0 }],
        [
          { daubed: !1 },
          { daubed: !0 },
          { daubed: !1 },
          { daubed: !0 },
          { daubed: !1 }
        ],
        [{ daubed: !0 }, { daubed: !0 }, { daubed: !0 }, { daubed: !0 }, { daubed: !0 }],
        [
          { daubed: !1 },
          { daubed: !0 },
          { daubed: !1 },
          { daubed: !0 },
          { daubed: !1 }
        ]
      ];
    case o.FULL_CARD:
      return [
        [{ daubed: !0 }, { daubed: !0 }, { daubed: !0 }, { daubed: !0 }, { daubed: !0 }],
        [{ daubed: !0 }, { daubed: !0 }, { daubed: !0 }, { daubed: !0 }, { daubed: !0 }],
        [{ daubed: !0 }, { daubed: !0 }, { daubed: !0 }, { daubed: !0 }, { daubed: !0 }],
        [{ daubed: !0 }, { daubed: !0 }, { daubed: !0 }, { daubed: !0 }, { daubed: !0 }],
        [{ daubed: !0 }, { daubed: !0 }, { daubed: !0 }, { daubed: !0 }, { daubed: !0 }]
      ];
    case o.CORNERS:
      return [
        [
          { daubed: !0 },
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !0 }
        ],
        [
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !1 }
        ],
        [
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !1 }
        ],
        [
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !1 }
        ],
        [
          { daubed: !0 },
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !0 }
        ]
      ];
    case o.EDGES:
      return [
        [{ daubed: !0 }, { daubed: !0 }, { daubed: !0 }, { daubed: !0 }, { daubed: !0 }],
        [
          { daubed: !0 },
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !0 }
        ],
        [
          { daubed: !0 },
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !0 }
        ],
        [
          { daubed: !0 },
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !0 }
        ],
        [{ daubed: !0 }, { daubed: !0 }, { daubed: !0 }, { daubed: !0 }, { daubed: !0 }]
      ];
    case o.X_SHAPE:
      return [
        [
          { daubed: !0 },
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !0 }
        ],
        [
          { daubed: !1 },
          { daubed: !0 },
          { daubed: !1 },
          { daubed: !0 },
          { daubed: !1 }
        ],
        [
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !0 },
          { daubed: !1 },
          { daubed: !1 }
        ],
        [
          { daubed: !1 },
          { daubed: !0 },
          { daubed: !1 },
          { daubed: !0 },
          { daubed: !1 }
        ],
        [
          { daubed: !0 },
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !1 },
          { daubed: !0 }
        ]
      ];
    default:
      return [];
  }
}
const we = {
  large: "h-32 w-32",
  medium: "h-24 w-24",
  small: "h-16 w-16"
};
function pe({ className: e, pattern: r, size: s = "small" }) {
  const c = ve(r);
  return /* @__PURE__ */ t("div", { className: d("overflow-hidden rounded-lg shadow-lg", we[s], e), children: /* @__PURE__ */ t("div", { className: "grid grid-cols-5 gap-1 bg-shade-3 p-1", children: c.map((n, i) => /* @__PURE__ */ t("div", { className: "grid grid-rows-5 gap-1", children: n.map((h, m) => /* @__PURE__ */ t(
    "div",
    {
      className: d("aspect-square rounded-md", {
        "bg-blue-500 text-white": h.daubed,
        "bg-shade-0": !h.daubed
      })
    },
    m
  )) }, i)) }) });
}
function xe(e) {
  switch (e) {
    case o.ONE_LINE:
      return /* @__PURE__ */ l("span", { children: [
        "At least one line",
        " ",
        /* @__PURE__ */ l("strong", { children: [
          "in ",
          /* @__PURE__ */ t("u", { children: "any" }),
          " direction"
        ] }),
        "."
      ] });
    case o.TWO_LINES:
      return /* @__PURE__ */ l("span", { children: [
        "At least two lines",
        " ",
        /* @__PURE__ */ l("strong", { children: [
          "in ",
          /* @__PURE__ */ t("u", { children: "any" }),
          " direction"
        ] }),
        "."
      ] });
    case o.THREE_LINES:
      return /* @__PURE__ */ l("span", { children: [
        "At least three lines",
        " ",
        /* @__PURE__ */ l("strong", { children: [
          "in ",
          /* @__PURE__ */ t("u", { children: "any" }),
          " direction"
        ] }),
        "."
      ] });
    case o.FOUR_LINES:
      return /* @__PURE__ */ l("span", { children: [
        "At least four lines",
        " ",
        /* @__PURE__ */ l("strong", { children: [
          "in ",
          /* @__PURE__ */ t("u", { children: "any" }),
          " direction"
        ] }),
        "."
      ] });
    case o.FULL_CARD:
      return /* @__PURE__ */ t("span", { children: "Every square on the card." });
    case o.X_SHAPE:
      return /* @__PURE__ */ l("span", { children: [
        "Both diagonal lines - an ",
        /* @__PURE__ */ t("strong", { children: "X" }),
        " shape."
      ] });
    case o.CORNERS:
      return /* @__PURE__ */ l("span", { children: [
        "Each of the ",
        /* @__PURE__ */ t("strong", { children: "four corner squares" }),
        "."
      ] });
    case o.EDGES:
      return /* @__PURE__ */ t("span", { children: "Four lines on the outer borders of the card." });
  }
}
function Ee(e) {
  switch (e) {
    case o.ONE_LINE:
      return "One Line";
    case o.TWO_LINES:
      return "Two Lines";
    case o.THREE_LINES:
      return "Three Lines";
    case o.FOUR_LINES:
      return "Four Lines";
    case o.FULL_CARD:
      return "Full Card";
    case o.X_SHAPE:
      return "X Shape";
    case o.CORNERS:
      return "Four Corners";
    case o.EDGES:
      return "Edges";
  }
}
const ye = {
  large: { heading: "extra-large" },
  medium: { heading: "large" },
  small: { heading: "medium" }
};
function M1({ className: e, pattern: r, size: s = "medium" }) {
  return /* @__PURE__ */ l("div", { className: d("text-center", e), children: [
    /* @__PURE__ */ t(S, { size: ye[s].heading, children: Ee(r) }),
    /* @__PURE__ */ t(k, { className: "mx-auto mt-2", children: xe(r) }),
    /* @__PURE__ */ t("div", { className: "flex justify-center p-6", children: /* @__PURE__ */ t(pe, { pattern: r, size: s }) })
  ] });
}
function I1({
  className: e,
  id: r,
  isChecked: s,
  isDisabled: c,
  onChange: n
}) {
  return /* @__PURE__ */ l("label", { className: d("flex flex-col items-center justify-center"), htmlFor: r, children: [
    /* @__PURE__ */ t(
      "input",
      {
        checked: s,
        className: "peer invisible size-0",
        disabled: c,
        id: r,
        type: "checkbox",
        onChange: n
      }
    ),
    /* @__PURE__ */ t(
      "div",
      {
        className: d(
          "h-6 w-10 after:left-1 after:h-4 after:w-4",
          "sm:h-8 sm:w-14 sm:after:left-1 sm:after:h-6 sm:after:w-6",
          "relative flex items-center rounded-full hover:cursor-pointer",
          "after:absolute after:rounded-full after:bg-white after:transition-all after:duration-300",
          "peer-checked:bg-purple-500 peer-checked:after:translate-x-full",
          "bg-shade-4",
          e
        )
      }
    )
  ] });
}
export {
  Ie as AirplaneIcon,
  R as AnimatedCheckmark,
  He as ArrowLeftIcon,
  E as Badge,
  v1 as BingoCard,
  k1 as Button,
  V1 as ButtonGroup,
  j as CheckCircleIcon,
  _ as CheckIcon,
  p1 as Checkbox,
  Le as ChevronLeftIcon,
  G as ChevronRightIcon,
  T as CloseIcon,
  ke as ComputerIcon,
  B1 as Container,
  Be as CopyIcon,
  Ve as CopyLinkIcon,
  k as Description,
  ze as DollarIcon,
  Ae as EditIcon,
  _e as ExpandIcon,
  Te as ExportIcon,
  Re as ExternalIcon,
  Oe as FacebookIcon,
  z as FeaturesList,
  x1 as GameBackground,
  S as Heading,
  Pe as HistoryIcon,
  z1 as IconButton,
  A1 as InfoCircleIcon,
  je as InstagramIcon,
  E1 as Label,
  oe as List,
  y1 as Logo,
  U as MINIMUM_SONG_COUNT,
  Ge as MenuIcon,
  C1 as MessageBanner,
  pe as MiniBingoCard,
  Ue as MinusIcon,
  Fe as MusicIcon,
  De as NextIcon,
  Xe as NotesIcon,
  I as Panel,
  We as PauseIcon,
  $e as PeopleIcon,
  Ye as PhoneIcon,
  Ze as PlayIcon,
  le as PlayerCardGrid,
  Qe as PlaylistIcon,
  qe as PlusIcon,
  Je as PodcastIcon,
  Ke as PreviousIcon,
  e1 as QuestionCircleIcon,
  fe as RankBadge,
  t1 as RockstarAnticsIcon,
  S1 as ScoreboardDisplay,
  N1 as ScoreboardItem,
  a1 as SettingsIcon,
  r1 as ShuffleIcon,
  be as Skew,
  s1 as SkullIcon,
  c1 as SpeakerIcon,
  _1 as Spinner,
  l1 as SpotifyIcon,
  ae as SquareComponent,
  L as SquareIcon,
  n1 as TabletIcon,
  M1 as TargetDisplay,
  d1 as TargetIcon,
  I1 as ToggleSwitch,
  i1 as TrashIcon,
  o1 as TriangleExclamationIcon,
  u1 as TwitterIcon,
  H as YoutubeIcon,
  h1 as contactUsUrl,
  m1 as facebookHostGroupUrl,
  g1 as knowledgeBaseUrl,
  w1 as markPlayerData,
  d as merge,
  f1 as podcastUrl,
  T1 as sleep,
  b1 as youtubeUrl
};
